import { mapGetters } from 'vuex';

export const RouteHub = {
  computed: {
    ...mapGetters('app', ['appConfig']),
  },
  methods: {
    routeOverview() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/overview';
    },
    routeEvent() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/events';
    },
    routeTopPlay() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/top_plays';
    },
    routeAnnouncement() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/announcements';
    },
    routeStreamAndChat() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/stream_and_chat';
    },
    routeSetting() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/settings';
    },
    routeMember() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/members';
    },
    routeTeam() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/teams';
    },
    routeLobby() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/lobby';
    },
    routeTweet() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/tweets';
    },
    routeAbout() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/about';
    },
    routeCollege() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/colleges';
    },
    routeHighSchoolTexSef() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/highschools';
    },
    routeLeaderboard() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/leaderboard';
    },
    routeRule() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/rules';
    },
    routeRequest() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/requests';
    },
    routeFindScrimmage() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/find_scrimmage';
    },
    routeCreateScrimmage() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/create_scrimmage';
    },
    routeManangeScrimmage() {
      return this.appConfig.baseUrl + '/' + this.hubData.hub_data.alias + '/manage_scrimmage';
    },
    routeViewResource() {
      return this.appConfig.baseUrl + '/view-resources';
    },
    routeGetMemberLeaderBoard() {
      return this.appConfig.baseUrl + '/hub/get-member-leaderboard';
    },
    routeGetMemberLeaderBoardWeekly() {
      return this.appConfig.baseUrl + '/hub/get-member-leaderboard-weekly';
    },
    routeScrimmageEvent(alias, scrimmageId, tabName = '') {
      return this.appConfig.baseUrl + '/' + alias + '/scrimmages/' + scrimmageId + '/' + tabName;
    },
    routeDisconnectDiscordServer() {
      return this.appConfig.baseUrl + '/hub/disconnect-discord-server';
    },
    routeCheckValidHost() {
      return this.appConfig.baseUrl + '/hub/check_valid_host';
    },
    routeConnectDiscord() {
      return this.appConfig.baseUrl + '/discordapp/oauth?redirect_uri=' + location.href + '&join_for_tour=1';
    },
    routeSaveAnnoucement() {
      return this.appConfig.baseUrl + '/hub/save_announcement';
    },
    routeRequestTeam() {
      return this.appConfig.baseUrl + '/hub/request-team';
    },
    routeRemoveMemberFromTeam() {
      return this.appConfig.baseUrl + '/hub/remove_member_from_team';
    },
    routeUpdateTeamRole() {
      return this.appConfig.baseUrl + '/hub/update_team_role';
    },
    routeHubSearchMember() {
      return this.appConfig.baseUrl + '/hub/search-member';
    },
    routeRequestAdmin() {
      return this.appConfig.baseUrl + '/hub/request-admin';
    },
    routeRequestLeader() {
      return this.appConfig.baseUrl + '/hub/request-leader';
    },
    routeHandleRequestLeader() {
      return this.appConfig.baseUrl + '/hub/handle-request-leader';
    },
    routeUpdateHubAbout() {
      return this.appConfig.baseUrl + '/hub/update-hub-about';
    },
  },
};
